import React, { useState } from "react";
import { Button, Steps, theme } from "antd";
import ContentDetailForm from "../components/Content/ContentDetailForm";
import { useContext } from "react";
import { context } from "../context/context";
import { http } from "../services/httpService";
import config from "../services/config.json";
import AddMedia from "./../components/Content/AddMedia";
import { useNavigate } from "react-router";
import { NavLink } from "react-router-dom";
import toast from "react-hot-toast";
const steps = [
    {
        title: "ویرایش جزئیات محتوا",
        content: <ContentDetailForm />,
    },
    {
        title: "انتخاب عکس",
        content: <AddMedia />,
    },
];
const AddContent = () => {
    const { token } = theme.useToken();
    const [current, setCurrent] = useState(0);
    const {
        addNamePlace,
        isCategorySelected,
        isCountrySelected,
        isProvinceSelected,
        addPhonePlace,
        linkTags,
        textEditorHTML,
        selectedCategoryId,
        selectedCityId,
        selectedCountry,
        selectedProvince,
        placeFormTag,
        coverPicId,
        fileListIds,
        setFileList,
        setCoverPic,
        contentId,
        setFileListIds,
        editedSubCategory,
    } = useContext(context);
    const next = () => {
        if (current === 0) {
            http.post(`${config.parkopoloApi}/api/Content/addContent`, {
                contentId: contentId,
                title: addNamePlace,
                tags: placeFormTag,
                province: selectedProvince._id,
                country: selectedCountry._id,
                city: selectedCityId,
                village: selectedCityId,
                category: selectedCategoryId,
                subCategory: editedSubCategory,
                data: textEditorHTML,
                links: linkTags,
                phone: addPhonePlace,
            })
                .then((res) => {
                    console.log(res);
                })
                .catch((err) => {
                    console.log(err);
                });
        }
        setCurrent(current + 1);
    };
    const navigate = useNavigate();
    const handleSendMedia = () => {
        http.post(`${config.parkopoloApi}/api/Content/addMedia`, {
            contentId: contentId,
            coverPic: coverPicId,
            media: fileListIds,
        })
            .then((res) => {
                toast.success("محتوا با موفقیت ویرایش شد !", {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    progress: undefined,
                    theme: "colored",
                    style: { fontFamily: "Vazir" },
                });
            })
            .catch((err) => {
                toast.error("خطایی رخ داد !", {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    progress: undefined,
                    theme: "colored",
                    style: { fontFamily: "Vazir" },
                });
                console.log(err);
            });
        setFileList([]);
        setFileListIds([]);
        setCoverPic([]);
        navigate("/content", { replace: true });
    };
    const items = steps.map((item) => ({
        key: item.title,
        title: item.title,
    }));
    const contentStyle = {
        lineHeight: "260px",
        textAlign: "center",
        color: token.colorTextTertiary,
        backgroundColor: token.colorFillAlter,
        borderRadius: token.borderRadiusLG,
        border: `1px dashed ${token.colorBorder}`,
        marginTop: 16,
    };
    return (
        <div style={{ direction: "ltr" }}>
            <Steps current={current} items={items} />
            <div style={contentStyle}>{steps[current].content}</div>
            <div
                style={{
                    marginTop: 24,
                    textAlign: "left",
                    display: "flex",
                    gap: "10px",
                }}
            >
                {current < steps.length - 1 && (
                    <div>
                        <Button
                            type="primary"
                            onClick={() => next()}
                            disabled={
                                current === 0 &&
                                (!addNamePlace ||
                                    addNamePlace === "" ||
                                    !isCategorySelected ||
                                    !isCountrySelected ||
                                    !isProvinceSelected ||
                                    !selectedCityId)
                            }
                        >
                            مرحله بعد
                        </Button>
                    </div>
                )}
                {current === steps.length - 1 && (
                    <Button type="primary" onClick={() => handleSendMedia()}>
                        ثبت
                    </Button>
                )}
                <NavLink to="/content">
                    <Button type="primary" danger>
                        لغو
                    </Button>
                </NavLink>
            </div>
        </div>
    );
};
export default AddContent;
